export default "/fonts/vendor/katex/dist/KaTeX_Script-Regular.woff2?c81d1b2a4b75d3eded6059a210910a6b";